<template>
  <div class="container">
    <template v-if="loading">
      <div class="loading">
        <img src="../assets/loading.gif" alt="loading">
      </div>
    </template>
    <template v-else>
      <div class="logo" @click="toHome">
        <img src="../assets/logo.png" alt="logo">
      </div>
      <div class="search">
        <input type="text" v-model="keyword" @keyup.enter="toSearch">
        <img src="../assets/search.webp" alt="search" @click="toSearch">
      </div>
      <div class="tab">

      </div>
      <ol class="list" v-if="list.length > 0">
        <ins class="adsbygoogle"
             style="display:block"
             data-ad-client="ca-pub-6626240105039250"
             data-ad-slot="6956288491"
             data-ad-format="auto"
             data-full-width-responsive="true">
        </ins>
        <li class="poetry" v-for="(item, index) in list" @click="toDetail(item)">
          <a class="title" v-html="item.title">
          </a>
          <p class="content" v-html="item.content">
          </p>
        </li>
        <div class="next" @click="next" v-if="list.length >= 20">
          下一页
        </div>
      </ol>
      <div class="empty" v-else>
        <img src="../assets/empty.png" alt="empty">
        <span>什么也没有</span>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageNum: 1,
      keyword: '',
      list: [],
      loading: true
    }
  },
  methods: {
    next() {
      this.pageNum = this.pageNum + 1;
      this.search();
    },
    search() {
      this.loading = true;
      document.title = this.keyword + '-诗词馆';
      this.$get('/poetryapi/poetry/list', {pageNum: this.pageNum, pageSize: 20, keyword: this.keyword}).then(res => {
        const list = res || [];
        list.forEach((item, i) => {
          item.content = item.content.split(this.keyword).join('<span class="highlight">' + this.keyword + '</span>');
          item.title = [item.name, item.dynasty, item.poetName].join('·');
          item.title = item.title.split(this.keyword).join('<span class="highlight">' + this.keyword + '</span>');
        });

        this.list = res || [];
        this.loading = false;

        document.getElementsByClassName('search')[0].scrollIntoView({
          behavior: 'smooth'
        });
      }).catch(e => {
        this.loading = false;
      });
    },
    toSearch() {
      if (this.keyword && this.keyword != this.$route.params.keyword) {
        this.$router.push('/search/' + this.keyword);
      }
    },
    toDetail(item) {
      this.$router.push('/poetry/' + item.id);
    },
    toHome() {
      this.$router.push('/');
    }
  },
  mounted() {
    this.keyword = this.$route.params.keyword;
    this.search();
  },
  watch: {
  	  '$route' (to, from) {
        if (from.name == 'Home' || from.name == to.name) {
    		  if(to.params.keyword != from.params.keyword){
    			  this.keyword = to.params.keyword;
            this.pageNum = 1;
            this.list = [];
    			  this.search();
    		  }
        }
  	  }
  },
}
</script>

<style lang="less" scoped>
.container {
  width: 100vw;

  .loading {
    width: 100vw;
    height: 100vh;
    background: rgba(00, 00, 00, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 48px;
      height: 48px;
    }
  }
  .logo {
    margin-top: 6px;
    text-align: center;

    img {
      width: 36px;
      height: 36px;
    }
  }
  .search {
    margin: 6px 12px 0;
    background: #FFFFFF;
    border-radius: 6px;
    height: 42px;
    display: flex;
    box-shadow: 0 1px 3px 1px rgba(0,0,0,.14);
    -webkit-box-shadow: 0 1px 3px 1px rgba(0,0,0,.14);

    input {
      flex: 1;
      background: rgba(00, 00, 00, 0);
      border: none;
      padding: 3px 12px;
    }
    input:focus{
      outline: none;
    }
    img {
      width: 30px;
      height: 30px;
      padding: 6px;
    }
  }

  .list {
    border: 0;
    border-collapse: collapse;
    border-spacing: 0;
    list-style: none;
    padding: 0;

    .poetry {
      margin: 12px 12px 0 12px;
      border-radius: 6px;
      padding: 12px;
      background: #FFFFFF;
      box-shadow: 0 1px 3px 1px rgba(0,0,0,.14);
      -webkit-box-shadow: 0 1px 3px 1px rgba(0,0,0,.14);

      .title {
        font-size: 18px;
        line-height: 22px;
        text-decoration: none;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      a {
        color: #003dbf;
      }
      .content {
        font-size: 14px;
        line-height: 20px;
        margin: 0;
        margin-top: 6px;
        padding: 0;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5;
        overflow: hidden;
      }

      /deep/ .highlight {
        color: #c00;
      }
    }

    .next {
      margin: 12px 12px 0 12px;
      background: #FFFFFF;
      border-radius: 6px;
      padding: 12px;
      text-align: center;
      cursor: pointer;
    }
  }

  .empty {
    text-align: center;
    margin-top: 96px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 60px;
      height: 60px;
    }
    span {
      margin-top: 3px;
      font-size: 14px;
      color: #888888;
    }
  }
}
</style>
